
function nen(omschrijving,code,belang,intensiteit,omvang) {
    return  { 
        'omschrijving' : omschrijving,
        'belang' : belang,
        'intensiteit' : intensiteit,
        'omvang' : omvang,
        'code' : code
    };
}

export const NEN2767Mixin = {
    methods: {
        
    },
    data() {
        return {
            gebrekenboek : [{
                'label' : 'kooi-schachtdeuren',
                'children' : [
                    nen('Defecte deurrol van automatische schuifdeur','T1EW05',	1,3,	1),
                    nen('Niet goed sluitende deur','TT1EW01',	1	,3,	1),
                    nen('Niet functioneren van deurcontact, grendel, sensor en fotocel','TT1EW06',	1	,3,	1),
                    nen('Gebroken vensterglas in kooi, schachtwand en/of toegang','TT1EC03',	1	,3,	1),
                    nen('Deformatie van automatische schuifdeur, deurrails of kozijn','TT1EC08',	1,null,null),
                    nen('Ontbreken van ondergeleidingssloffen, vensterglas in deur, deurhandgreep, signaleringscomponent','TT1EB03', 	1, 	3, 	1), 
                    nen('Defecte deurdranger en -buffer','TT1SW01',	2,	3,	1),
                    nen('Scheefstaande sluiting en buffer','T1SC03',	2,	2,	1),
                    nen('Niet goed afgestelde schachttoegang','T1GO05',	3,	3,	1)
                ]
            },
            {
                'label' : 'kooi',
                'children' : [
                    nen('Gebroken leislofvoering of gebroken leislof','T1EC04',1,3,1),
                    nen('Ontbreken van niet verplichte veiligheidsvoorziening (bv lichtlijst)','T1GV01',3,2,5),
                    nen('Niet-automatische smering van leislof','T1SB03',2,3,1),
                    nen('Smeerautomaat is niet van behoorlijk smeerkatoen voorzien','T1SB04',2,3,1),
                    nen('Gebroken kap van kooiverlichtingsarmaturen','T1SB05',2,3,1),
                    nen('Niet nauwkeurig in te stellen dosering van smeerautomaat','T1SB10',2,3,1),
                    nen('Losgeraakte kooibekleding en/of -afwerking','T1SC01', 2,null,null),	
                    nen('Materiaalaantasting aan oppervlak','T1GA02',3,null,5),
                    nen('Onvoldoende vulling van smeerautomaat','T1GO10',3,3,1),
                    nen('Verval kooideur > 87,5% van de theoretische levensduur','T1GV01',3,3,5),
                    nen('Verval kooideur > 75% maar < 87,5% van de theoretische levensduur','T1GV01',3,2,5),
                    nen('Verval kooideur > 50% maar < 75% van de theoretische levensduur','T1GV02',3,1,5),
                    nen('Verval kooideur < 50% van de theoretische levensduur','T1GV02',3,1,1),
                ]
            },
            {
                'label' : 'constructies in de schacht',
                'children' : [
                    nen('Loszittend deel zoals geleider van kooi, tegengewicht, sluiting, buffer','T1EC05',1,null,1),
                    nen('Trillen van snelheidsbegrenzer, as, kabel, tractieschijf, afleidschijf, remvoering','T1EM02',1,null,1),
                    nen('Tordering of verandering in uitlijning van geleider', 'T1SC02',2,null,null),
                ]
            },
            {
                'label' : 'aandrijving',
                'children' : [
                    nen('Speling dubbeldruklager wormas','T1EW09',1,null,null),
                    nen('Draadbreuk in draagkabel','T1EC06',1,3,null),
                    nen('Breuk van band of as','T1EC07',1,3,null),
                    nen('Speling lager hoofdas (tractieschijf)','T1EW08',1,null,5),
                    nen('Flankenspeling wormoverbrenging','T1EW10',1,null,5),
                    nen('Trillen van worm, wormwiel, kettingschalm, koppelingsrubber','T1EM02',1,null,1),
                    nen('Asbesthoudende remvoering','T1EB01',1,3,1),
                    nen('Olielekkage van aandrijfmachine, oliekering, pakking, reductiekast','T1SW02',2,null,1),
                    nen('Olielekkage van ventielenblok, vloeistofbak, veiligheidsklep, leiding, cilinder','T1SW02',2,null,1),
                    nen('Overmatige warmteontwikkeling door overbelasting van motor, reductiekast, rem','T1SB09',2,3,null),
                    nen('Onvoldoende opbrengst van vloeistofpomp','T1SB12',2,3,null),
                    nen('Niet goed afgestelde elektronische machineregelcomponent','T1GO04',3,3,1),
                    nen('Onvoldoende smering van leischijf, draagkabel','T1GO06',3,3,1),
                    nen('Niet-correcte uitlijning van motor en reductiekast','T1GB02',3,null,1),
                    nen('Te geringe hoeveelheid hydraulische vloeistof','T1GO01',3,3,2),
                    nen('Verval elektrische aandrijving > 87,5% van de theoretische levensduur','T1GV01',3,3,5),
                    nen('Verval elektrische aandrijving > 75% maar < 87,5% van de theoretische levensduur','T1GV01',3,2,5),
                    nen('Verval elektrische aandrijving > 50% maar < 75% van de theoretische levensduur','T1GV02',3,1,5),
                    nen('Verval elektrische aandrijving < 50% van de theoretische levensduur','T1GV02',3,1,1),
                    nen('Verval hydraulische aandrijving > 87,5% van de theoretische levensduur','T1GV01',3,3,5),
                    nen('Verval hydraulische aandrijving > 75% maar < 87,5% van de theoretische levensduur','T1GV01',3,2,5),
                    nen('Verval hydraulische aandrijving > 50% maar < 75% van de theoretische levensduur','T1GV02',3,1,5),
                    nen('Verval hydraulische aandrijving < 50% van de theoretische levensduur','T1GV02',3,1,1)
                ]
            },
            {
                'label' : 'besturing',
                'children' : [
                    nen('Defecten aan of disfunctioneren van elektronische componenten','T1EW04',1,3,1),
                    nen('Ingebrande bedrading en contractor','T1EM03',1	,null,1),
                    nen('Verdroogde hangleiding','T1EM04',1	,null,1),
                    nen('Stopverschillen door onnauwkeurige afstelling van besturingscomponenten','T1SB06',2,null,1),
                    nen('Afwijking van snelheid van instelwaarde van de regeling','T1SW03',2,null,null),
                    nen('Leiding met te geringe doorsnede','T1SB08',2,3,null),
                    nen('Veroudering/verval/verdroging kabelisolatie','T1GB06',3,null,null),
                    nen('Losse of ontbrekende schroef van besturingstableau','T1GB07',3,3,1),
                    nen('Klemnummering of nummering componenten besturing ontbreekt','T1GA04',3,3,1),
                    nen('Niet goed ingevoerde of aangesloten leidingen','T1GB01',3,null,1),
                    nen('Leidingen blootgesteld aan scherpe randen','T1GB01',3,null,1),
                    nen('Onvoldoende bevestiging van noodeindschakelaar, hangleiding, bedieningscomponent','T1GB03',3,null,1),
                    nen('Niet geheel strakke of gesloten liftschachtleiding	','T1GB04',3,null,1),
                    nen('Slordige bedrading van regeling','T1GB05',	3,null,1),
                    nen('Verval besturing > 87,5% van de theoretische levensduur','T1GV01',3,3,5),
                    nen('Verval besturing > 75% maar < 87,5% van de theoretische levensduur','T1GV01',3,2,5),
                    nen('Verval besturing > 50% maar < 75% van de theoretische levensduur','T1GV02',3,1,5),
                    nen('Verval besturing < 50% van de theoretische levensduur','T1GV02',3,1,1),
                    nen('Verval frequentieregelaar > 87,5% van de theoretische levensduur','T1GV01',3,3,5),
                    nen('Verval frequentieregelaar > 75% maar < 87,5% van de theoretische levensduur','T1GV01',3,2,5),
                    nen('Verval frequentieregelaar > 50% maar < 75% van de theoretische levensduur','T1GV02',3,1,5),
                    nen('Verval frequentieregelaar < 50% van de theoretische levensduur','T1GV02',3,1,1),
                ]
            },
            {
                'label' : 'schachtdeuren',
                'children' : [
                    nen('Afgescheurd deurscharnier of gebroken scharnierpen','T1EC09',1,3,1),
                    nen('Scheefstaande sluiting en buffer','T1SC03',2,2,1),
                    nen('Niet goed afgestelde schachttoegang','T1GO05',3,3,1),
                    nen('Verval schachtdeur > 87,5% van de theoretische levensduur','T1GV01',3,3,5),
                    nen('Verval schachtdeur > 75% maar < 87,5% van de theoretische levensduur','T1GV01',3,2,5),
                    nen('Verval schachtdeur > 50% maar < 75% van de theoretische levensduur','T1GV02',3,1,5),
                    nen('Verval schachtdeur < 50% van de theoretische levensduur','T1GV02',3,1,1),
                ]
            },
            {
                'label' : 'algemeen',
                'children' : [
                    nen('Gescheurde of verwrongen bevestiging','T1EC01',1,null,null),
                    nen('Beschadiging (gaten)','T1EC02',1,3,null),
                    nen('Corrosie','T1EM01',1,null,null),
                    nen('Defecten aan of disfunctioneren van element zoals aandrijving','T1EW02',1,null,1),
                    nen('Defecten aan element zoals stuiting, leislof, drempelcontact, vastzetinrichting, verlichting, spanwiel, leischijf','T1EW03',1,3,1),
                    nen('Defecte ventilatie van machinekamer en schijvenruimte','T1SB01',2,3,1),
                    nen('Onvoldoende schachtverlichting','T1SB11',2,3,1),
                    nen('Beschadiging (deuken)','T1SC04',2,3,null),
                    nen('Vervangende onderdelen niet meer verkrijgbaar','T1SB07',2,null,null),
                    nen('Vervuiling','T1GO02',3,null,null),
                    nen('Bekladding','T1GO03',3,null,null),
                    nen('Ontbreken van of niet bijgehouden reparatie- en storingslogboek','T1GO07',3,1,1),
                    nen('Oude overtollige materialen niet afgevoerd','T1GO09',3,1,1),
                    nen('Beschadiging (krassen)','T1GA01',3,null,1),
                    nen('Materiaalaantasting aan oppervlak','T1GA02',3,null,1)
                ]
            },
            {
                'label' : 'veiligheid',
                'children' : [
                    nen('Defecten aan of disfunctioneren van elektronische componenten','T1EW04',1,3,1),
                    nen('Ontbreken van niet verplichte veiligheidsvoorziening (bv lichtlijst)','T1GV01',3,2,5),
                    nen('Ontbreken of falen van veiligheidsvoorziening','T1EB02',1,3,null),
                    nen('Ontbreken van ARBO-veiligheid met categorie 1 en 2','T1EB04',1,3,null),
                    nen('Niet functionerende spreek-luisterverbinding','T1EW07',1,3,1),
                    nen('Plaats van schakelaar onjuist','T1SB02',2,3,1),
                    nen('Verval accuset noodstroomvoorziening < 50% van de theoretische levensduur','T1GV02',3,1,1),
                    nen('Overbrugde beveiliging, eindschakelaar','T1GB08',3,3,1),
                    nen('Verplichte keuring niet uitgevoerd','T1GO08',3,1,1),
                    nen('Ontbreken van tekstplaat op hijsbalk, schakelkast en deur van liftmachinekamer','T1GA03',3,3,1),
                    nen('Verval accuset noodstroomvoorziening > 87,5% van de theoretische levensduur','T1GV01',3,3,5),
                    nen('Verval accuset noodstroomvoorziening > 50% maar < 75% van de theoretische levensduur','T1GV02',3,1,5),
                    nen('Verval accuset noodstroomvoorziening > 75% maar < 87,5% van de theoretische levensduur','T1GV01',3,2,5),
                    nen('Verval noodverlichting liftmachinekamer, schachtput en kooidak > 75% maar < 87,5% van de theoretische levensduur','T1GV01',3,2,5),
                    nen('Verval noodverlichting liftmachinekamer, schachtput en kooidak > 50% maar < 75% van de theoretische levensduur','T1GV02',3,1,5),
                    nen('Verval noodverlichting liftmachinekamer, schachtput en kooidak < 50% van de theoretische levensduur','T1GV02',3,1,1),
                ]
            },
            {
                'label' : 'technisch',
                'children' : [
                    nen('Ontbreken, in situatie gewenst onderdeel','T1GV02',3,1,5),
                    nen('Verval > 50% maar < 75% van de theoretische levensduur','T1GV02',3,1,5),
                    nen('Verval > 75% maar < 87,5% van de theoretische levensduur','T1GV01',3,2,5),
                    nen('Verval < 50% van de theoretische levensduur','T1GV02',3,1,1),
                    nen('Verval > 87,5% van de theoretische levensduur','T1GV01',3,3,5),
                ]
            },{
                'label' : 'liftmachinekamer',
                'children' : [
                    nen('Verval noodverlichting liftmachinekamer,schachtput en kooidak > 87,5% van de theoretische levensduur','T1GV01',3,3,5),
                ]
            }]
        }
    }
}
